import React, {useState, useEffect} from 'react'
import Button from 'react-bootstrap/Button'
import PTextarea from './PTextarea';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Spinner from 'react-bootstrap/Spinner';
import CommentItem from './comment-item';
import { comment } from 'postcss';

const PPostComment = ({post, showComment, setCommentCount, user}) => {
  const [caption, setCaption] = useState('')
  const [comments, setComments] = useState([])
  const [page, setPage] = useState(1)
  const [perPage, setPerPage] = useState(10)
  const [isLoading, setIsLoading] = useState(false)
  const [hasMore, setHasMore] = useState(false)

  const getComments = async () => {
    await axios.get(`/api/comments`, {
      params: {
        post_id: post.id,
        per_page: perPage,
        page: page
      }
    }).then(response => {
      setHasMore(perPage*page < response.data.total)
      const commentIds = new Set(comments.map(comment => comment.id));
      setComments([...comments, ...response.data.data.filter(d => !commentIds.has(d.id))])
    })
  }

  useEffect(() => {
    getComments()
  }, [page])

  const handleShowMore = (e) => {
    e.preventDefault()
    setPage(page => page+1)
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setIsLoading(true)
    await axios.post('/api/comments', {
      comment: caption,
      post_id: post.id
    }).then(response => {
      setCaption('')
      comments.push(response.data)
      setComments([...comments])
      setCommentCount(1)
    }).catch(error => {})
    .finally(() => {
      setIsLoading(false)
    })
  }

  const handleDelete = (index, subIndex=null) => {
    let counter = 1;
    if (comments[index].comments && subIndex === null) {
      counter = counter + comments[index].comments.length
    }

    if (subIndex === null) {
      comments.splice(index, 1)
      setCommentCount(-counter)
    } else {
      comments[index].comments.splice(subIndex, 1)
    }
    setComments([...comments])
  }

  const setCommentHandler = (index, subIndex=null, payload, mode='add', reply=false) => {
    if (subIndex === null && mode === 'add') {
      comments[index].comments.push(payload)

      if (!reply) {
        setCommentCount(1)
      }
    } else if(subIndex !== null && mode === 'edit') {
      comments[index].comments[subIndex].comment = payload
    } else if(subIndex === null && mode === 'edit') {
      comments[index].comment = payload
    }
    setComments([...comments])
  }

  return (
    <div className={'posts-list-item-comment-container' + `${showComment ? ' active' : ''}`}>
      <div className="posts-list-item-comments-list">
      {
        comments.map((comment, index) => (
          <div key={comment.id}>
            {
              comment.comments && comment.comments.length > 0 && <React.Fragment>
                <CommentItem
                  comment={comment}
                  key={comment.id}
                  index={index}
                  deleteHandler={handleDelete}
                  post={post}
                  setCommentHandler={setCommentHandler}
                /> 
                {
                  comment.comments.map((subComment, subIndex) => {
                    return <CommentItem
                      comment={subComment}
                      key={subComment.id}
                      index={index}
                      subIndex={subIndex}
                      deleteHandler={handleDelete}
                      post={post}
                      setCommentHandler={setCommentHandler}
                    />
                  })
                }
              </React.Fragment>
            }
            {
              comment.comments.length <= 0 && <CommentItem
                  comment={comment}
                  key={comment.id}
                  index={index}
                  deleteHandler={handleDelete}
                  post={post}
                  setCommentHandler={setCommentHandler}
                />
            }
          </div>
        ))
      }
      {
          hasMore && <div className="comment__more py-4 pl-2 text-sm">
          <a href="" onClick={handleShowMore}>Show more comments</a>
        </div>
      }
      </div>
      <form className="comment_form" method="post" name="comment_form">
        <div className="comment_form_field">
          <PTextarea
            caption={caption}
            setCaption={setCaption}
            placeholder="Write your comment..."
            user={user}
          />
        </div>
        <div className="comment_form_submit_cont">
          <Button
            type="submit"
            className="comment_form_submit-btn"
            onClick={handleSubmit}
            disabled={isLoading}
          >
            {isLoading
              ? <Spinner animation="border" variant="light" />
              : <FontAwesomeIcon icon={['fas', 'paper-plane']} />}
          </Button>
        </div>
      </form>
    </div>
  )
}

export default React.memo(PPostComment)